import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-configuration',
  templateUrl: './registration-configuration.component.html',
  styleUrls: ['./registration-configuration.component.scss']
})
export class RegistrationConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
